<template>
	<!-- modal reset password form start -->
  <div :class="vg_setPasswordModal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <!-- <button @click="closeModal()" class="delete" aria-label="close"></button> -->
        <p class="modal-card-title">Set Password</p>	
      </header>
      <section class="modal-card-body ph20">
        <form>
          <div class="field-group">
          
            <div class="field">
              <div class="control has-eye">
                <validation-provider
                    name="new password"
                    ref="new_password"
                    rules="required|min:8|verify_password"
                    vid="new_password"
                  >
                  <template #default="{ errors }">
                    <input
                      name="new password"
                      class="input"
                      v-model="form.password"
                      :type="new_password_show ? 'text' : 'password'"
                      placeholder="New password"
                    />
                    <span class="validation-error" v-html="errors[0]"></span>
                    <i :class="new_password_show ? 'fas fa-eye-slash' : 'fas fa-eye'"  @click.prevent="new_password_show = !new_password_show"></i>
                  </template>
                </validation-provider>
            </div>
          </div>
          <div class="field">
              <div class="control has-eye">
                <validation-provider
                    name="confirm new password"
                    ref="confirm_new_password"
                    rules="required|confirmed:new_password"
                  >
                  <template #default="{ errors }">
                    <input
                      name="confirm new password"
                      class="input"
                      v-model="form.password_confirmation"
                      :type="confirm_new_password_show ? 'text' : 'password'"
                      placeholder="Confirm New Password"
                    />
                    <span class="validation-error" v-html="errors[0]"></span>
                    <i :class="confirm_new_password_show ? 'fas fa-eye-slash' : 'fas fa-eye'" @click.prevent="confirm_new_password_show = !confirm_new_password_show"></i>
                  </template>
                </validation-provider>
            </div>
          </div>
        </div>
        </form>
      <!-- form end -->
      </section>
      <footer class="modal-card-foot">
        <button @click="updatePassword()" class="button is-large bg-secondary text-white hover-opacity-7 is-full-width">UPDATE</button>
      </footer>
    </div>
  </div>
	<!-- modal  reset password  form end -->
</template>

<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import UserApis from '@/Components/Controllers/UserApis';
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      new_password_show: false,
      confirm_new_password_show: false,
      form: {
        site_url: '',
        token : "",
        password: "",
        password_confirmation : "",

        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
        location_id: '',
        location_slug: '',
      }
    };
  },
  
  computed: {
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
      vg_locationSelected: "location/selected",
      vg_setPasswordModal: "setpassword/modal",
      vg_setPasswordToken: "setpassword/token",
    })
  },
  

  methods: {
    /**
     * Update password
     */
    async updatePassword() {
      const self = this;
      let validation = await Helpers.validateRefs(this, ['new_password', 'confirm_new_password']);
      if( validation ) {
        this.form.site_url = window.location.protocol + '//' + window.location.host + this.$route.path;
        this.form.token = this.vg_setPasswordToken;
        // Extra need to pass
        this.form.business_id = this.vg_businessProfile.id;
        this.form.business_name = this.vg_businessProfile.name;
        this.form.business_slug = this.$route.params.business_slug;
        this.form.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
        this.form.location_id = this.vg_locationSelected.id ? this.vg_locationSelected.id: '';
        this.form.location_slug = this.vg_locationSelected.slug ? this.vg_locationSelected.slug :'';

        let res = await UserApis.resetPasswordWithVerificationToken(this.form);
        if(res.status == 200){
          this.form = Helpers.setObjValueEmpty(this.form);
          // self.va_snackbar({
          //   type: 'success', 
          //   message: 'Password updated successfully.',
          // });
          this.vg_setPasswordObj({
            modal: false,
            token: '',
          })
        } 
        this.va_snackbar({
          type: res.status == 200 ? 'success' : 'warning',
          message: res.status == 200 ? res.data.msg : res.response.data.msg,
        });
      }
    },

    closeModal() {
      this.modal = false;
      this.form = Helpers.setObjValueEmpty(this.form);
      setTimeout(() => {
        for(let key in this.form){
          this.$refs[key].reset();
        }  
      }, 500)
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      vg_setPasswordObj: "setpassword/setObj",
    })
  },
};
</script>

<style scoped>
.field-group .field {
  border-bottom: 1px solid #e9e9e9;
}
</style>